module.exports = __webpack_public_path__ + "img/brand4.20c51527.jpg";